import React, { Component } from "react";
import moment from "moment";
import _ from "underscore";
import __ from "lodash";
import Loader from "react-loader-advanced";
import Modal from "react-modal";
import { connect } from "react-redux";

import get from "lodash/get";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import times from "lodash/times";
import toFinite from "lodash/toFinite";
import toString from "lodash/toString";

import Buttons from "./Buttons";
import SelectField from "./InputTypes/SelectField";
import InputField from "./InputTypes/InputField";
import TextareaField from "./InputTypes/TextareaField";
import DateInput from "./DateInput";
import CheckboxField from "./InputTypes/CheckboxField";
import OpportunityField from "./InputTypes/OpportunityField";
import InterlockField from "./InputTypes/InterlockField";
import ServiceRequestField from "./InputTypes/ServiceRequestField";
import AccountField from "./InputTypes/AccountField";
import LocationField from "./InputTypes/LocationField";
import Notice from "./Notice";
import Container from "../container";
import ActivityModal from "../Modals/ActivityModal";
import SubmitModal from "../Modals/SubmitModal";
import confirm, { alert } from "../Modals/ConfirmModal";
import BaseModal from "../Modals/BaseModal";
import AccountSearchSelectList from "../SelectLists/Types/AccountSearchSelectList";
import ProductGroupSearchSelectList from "../SelectLists/Types/ProductGroupSearchSelectList";
import DistributorSearchSelectList from "../SelectLists/Types/DistributorSearchSelectList";
import ServiceRequestSearchSelectList from "../SelectLists/Types/ServiceRequestSearchSelectList";
import OpportunitySearchSelectList from "../SelectLists/Types/OpportunitySearchSelectList";
import {
  calculateCategoryFieldsFor,
  shouldAddRequiredField,
} from "../../utils/category-fields";
import * as dateUtils from "../../utils/date";
import sentry from "../../utils/sentry";
import {
  modalController,
  toggleInput,
  toggleHistory
} from "../../actions/domActions";
import {
  addNotification,
  updateDefaultSelections
} from "../../actions/userActions";
import { setInputField } from "../../actions/fieldInputActions";
import { refreshEntries } from "../../actions/historyActions";

// SASS Imports
require("./TimeInput.scss");
import MODAL_SETTINGS, { SUBMIT_MODAL_SETTINGS } from "../../styles/modalSettings";
import loaderSettings from "../../styles/loaderSettings";

const MODAL_TIMEOUT = 2000;

const ONSITE_DETAIL_OPTIONS = [
  { label: "Not with customer", value: "not_with_customer" },
  { label: "On site with customer", value: "onsite_with_customer" },
  { label: "Virtually with customer", value: "virtually_with_customer" },
];

const ONSITE_DETAIL_VALUES = ONSITE_DETAIL_OPTIONS.map(({ value }) => value);

const ONSITE_DETAIL_DEFAULT = get(ONSITE_DETAIL_OPTIONS, "[0].value");

/**
 * @todo This component direly needs to be broken out. It is incomprehensibly long
 *  while simultaneously responsible for most of the core functionality of the app.
 */
class TimeInput extends Component {
  constructor(props) {
    super(props);

    this.initialState = deriveInitialStateFrom(props);

    this.state = { ...this.initialState };
  }

  componentDidMount() {
    const multiDayDurations = this.getMultiDayDurations(this.state.startDate, this.state.multiDayTimeEntryDaySpan);

    this.setState({ multiDayDurations });
  }

  componentDidUpdate(prevProps, prevState) {
    const isEditingOrCloning = this.props.entry.id || this.props.entry._clonedFrom;

    document.body.classList.toggle("isEditingOrCloning", isEditingOrCloning);

    if (propDiffNowBlank(this.props, prevProps, "settings.initialState")) {
      this.initialState.duration = getWorkingHoursFrom(this.props, this.initialState.dayNumber, "0.0");

      this.initialState.multiDayDurations = getMultiDayDurations(this.initialState.startDate, this.initialState.multiDayTimeEntryDaySpan, null, this.initialState, this.props);
    }

    this._maybeAdjustDates(prevProps, prevState);
    this._markCategoryMovement(prevProps);
    this._updateEntryHours(prevProps);
  }

  componentWillUnmount() {
    document.body.classList.remove("isEditingOrCloning");
  }

  _markCategoryMovement(prevProps) {
    // entry category has not changed
    if (prevProps.entry.categoryId === this.props.entry.categoryId) {
      return;
    }

    const shouldUseDefault = this.props.entry.categoryObject.fields
      && this.props.defaultServiceRequest
      && !this.props.entry.serviceRequestId;

    const fields = calculateCategoryFieldsFor(get(this.props, "entry.categoryObject"), this.props.user);

    this.setState({ fields }, () => {
      for (const [id, required] of Object.entries(fields)) {
        // If the field is hidden we remove the current value
        if (required === "hidden") {
          this.props.setInputField(id.toUpperCase(), null);
        } else if (id === "serviceRequest" && shouldUseDefault) {
          this.props.setInputField("SERVICEREQUEST", this.props.defaultServiceRequest);
        }
      }
    });
  }

  // Update entry hours if default working hours was changed in the settings
  _updateEntryHours(prevProps) {
    for (const i of times(this.props.workingHours.length)) {
      if (JSON.stringify(this.props.workingHours[i]) !== JSON.stringify(prevProps.workingHours[i])) {
        if (!this.state.singleDayDurationEdited) {
          const currentDayNumber = dateUtils.getDayNumber(this.state.singleDate);

          const duration = getWorkingHoursFrom(this.props, currentDayNumber);

          this.props.setInputField("HOURS", duration);
        }

        const multiDayDurations = this.getMultiDayDurations(
          this.state.startDate,
          this.state.multiDayTimeEntryDaySpan,
        );

        this.setState({ multiDayDurations });

        break;
      }
    }
  }

  _maybeAdjustDates(prevProps, prevState) {
    const setDefaultDate = (state, date) => ({
      ...state,
      singleDate: date.clone(),
      startDate: date.clone(),
      endDate: date.clone().add(1, "day"),
    });

    let newState = {};

    const { lastSavedDate: prevSavedDate } = prevState;
    const { lastSavedDate } = this.state;

    const currEntryDate = get(this.props, "entry.entryDate");
    const prevEntryDate = get(prevProps, "entry.entryDate");

    if (currEntryDate !== prevEntryDate) {
      if (currEntryDate) {
        newState.singleDate = dateUtils.stringApiToMoment(currEntryDate);
      } else if (lastSavedDate) {
        newState = setDefaultDate(newState, lastSavedDate);
      } else {
        newState.singleDate = this.initialState.singleDate.clone();
      }
    } else if (!currEntryDate && lastSavedDate !== prevSavedDate) {
      if (this._dateWidgetClick) {
        this._dateWidgetClick = false;
      } else if (lastSavedDate !== prevSavedDate) {
        newState = setDefaultDate(newState, lastSavedDate);
      }
    }

    propDiffThen(this.props, prevProps, "entry.comment", (comment) => {
      newState.comment = toString(comment).trim();
    });

    const isNowCloning = propDiffPresent(this.props, prevProps, "entry._clonedFrom");
    const isNowEditing = propDiffPresent(this.props, prevProps, "entry.id");

    if (isNowCloning || isNowEditing) {
      Object.assign(newState, {
        singleView: true,
        requiredFields: [],
        previousEditingHours: this.props.entry.hours,
        singleDayDurationEdited: true
      })

      if (isNowCloning && lastSavedDate) {
        newState = setDefaultDate(newState, lastSavedDate);
      }
    } else {
      // If new required fields don't contain pre-existing ones, remove them
      const newRequiredFields = _.intersection(
        this.state.requiredFields,
        this.getRequiredFields(this.props.entry, !this.state.singleView)
      );

      if (!_.isEqual(this.state.requiredFields, newRequiredFields)) {
        newState.requiredFields = newRequiredFields;
      }
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  }

  updateDuration(value) {
    this.props.setInputField("HOURS", value);
    this.setState({ singleDayDurationEdited: true });
  }

  updateDurationMulti(value, i, thisDate) {
    this.markMultiDayDurationFieldAsEdited(thisDate);

    const multiDayDurations = this.state.multiDayDurations;

    multiDayDurations[i].duration = value;

    this.setState({ multiDayDurations });
  }

  updateSingleDate(newDate) {
    const updateArgs = { singleDate: newDate };

    const shouldUpdate = !this.state.singleDayDurationEdited
      || this.props.entry.hours === "0.0";

    if (shouldUpdate) {
      const dayNumber = dateUtils.getDayNumber(newDate);
      const hours = this.props.workingHours[dayNumber].enabled
        ? this.props.workingHours[dayNumber].workingHours
        : "0.0";

      updateArgs.singleDayDurationEdited = false;
      updateArgs.duration = hours;
      this.props.setInputField("HOURS", hours);
    }

    this._dateWidgetClick = true;

    this.setState(updateArgs);
  }

  updateMultiDate(startDate, endDate) {
    const multiDayTimeEntryDaySpan = dateUtils.daysDiff(
      startDate.toDate(),
      endDate.toDate()
    ) + 1;

    const multiDayDurations = this.getMultiDayDurations(
      startDate,
      multiDayTimeEntryDaySpan,
      this.state.multiDayDurations
    );

    this._dateWidgetClick = true;

    this.setState({
      startDate,
      endDate,
      multiDayDurations,
      multiDayTimeEntryDaySpan
    });
  }

  getMultiDayDurations(startDate, daySpan, currentData) {
    return getMultiDayDurations(startDate, daySpan, currentData, this.state, this.props);
  }

  isMultiDayDurationFieldEdited(theDate) {
    return this.state.multiDayDurationEdited[
      dateUtils.dateToString(theDate)
    ];
  }

  markMultiDayDurationFieldAsEdited(theDate) {
    let currentMultiDayEditedInfo = this.state.multiDayDurationEdited;

    currentMultiDayEditedInfo[dateUtils.dateToString(theDate)] = true;

    this.setState({ multiDayDurationEdited: currentMultiDayEditedInfo });
  }

  onSelectAccount(account) {
    this.props.selectAccount(account);

    this.setState({ isAccountOpen: false });
  }

  onSelectOnsiteDetail(option) {
    const value = get(option, "value", null);

    this.props.setInputField("ONSITE_DETAIL", value);
  }

  onSelectProductGroup(productGroup) {
    const prefs = this.props.user.preferences.productLinePrefs;
    const productLines = productGroup.productLines;
    let updatedProductLine = null;

    this.props.selectProductGroup(productGroup);

    if (productLines && productLines.length === 1) {
      updatedProductLine = _.first(productLines);
    } else if (prefs && prefs[productGroup.productGroupId]) {
      updatedProductLine = _.find(productLines, (productLine) => (prefs[productGroup.productGroupId] === productLine.productLineId));
    }

    this.props.selectProductLine(updatedProductLine);
    this.setState({ isProductGroupOpen: false });
  }

  onSelectProductLine(productLine) {
    if (productLine && productLine.ref) {
      productLine = productLine.ref;
    }

    this.props.selectProductLine(productLine);
  }

  onSelectOpportunity(opportunity) {
    if (opportunity && opportunity.ref) {
      opportunity = opportunity.ref;
    }

    this.props.selectOpportunity(opportunity);
    this.setState({ isOpportunityOpen: false });
  }

  onSelectInterlock(interlock) {
    if (interlock && interlock.ref) {
      interlock = interlock.ref
    }

    this.props.selectInterlock(interlock);
  }

  onSelectLocation(location) {
    if (location && location.ref) {
      location = location.ref;
    }

    this.props.selectLocation(location);
  }

  onSelectDistributor(distributor) {
    this.props.selectDistributor(distributor);
    this.setState({ isDistributorOpen: false });
  }

  onSelectServiceRequest(serviceRequest) {
    this.props.selectServiceRequest(serviceRequest);
    this.setState({ isServiceRequestOpen: false });
  }

  getRequiredFields(entry, multiDay = false) {
    const category = get(entry, "categoryObject");
    const requiredFields = [];

    if (isNil(category) || isEmpty(category)) {
      requiredFields.push("category");

      return requiredFields;
    }

    const fields = get(category, "fields", []);

    for (const field of fields) {
      if (shouldAddRequiredField(field, entry)) {
        requiredFields.push(field.id);
      }
    }

    // Date validations
    if (multiDay) {
      // must log at least > 30 minutes
      if (this.getTotalDurationMultiDay() < 0.5) {
        requiredFields.push("multiDay-duration");
      }

      // disallow forecasting where disabled
      if (!category.allowForecasting && this.state.endDate.isAfter()) {
        requiredFields.push("endDate");
      }
    } else {
      const hours = toFinite(entry.hours);

      // must log gteq 30 minutes and less than 24 hours
      if (hours < 0.5 || hours > 24) {
        requiredFields.push("duration");
      }

      // disallow forecasting where disabled
      if (!category.allowForecasting && this.state.singleDate.isAfter()) {
        requiredFields.push("singleDate");
      }
    }

    return requiredFields;
  }

  checkRequiredFields() {
    const requiredFields = this.getRequiredFields(this.props.entry, !this.state.singleView);

    this.setState({ requiredFields });

    return requiredFields.length < 1;
  }

  getTotalDurationMultiDay() {
    return this.state.multiDayDurations.reduce(
      (acc, { duration }) => (acc + Number(duration)),
      0
    );
  }

  _areSaveButtonsEnabled() {
    const requiredFields = this.getRequiredFields(this.props.entry, !this.state.singleView);

    return requiredFields.length === 0;
  }

  async onSaveSingle(submit) {
    try {
      const entryDateString = dateUtils.dateToApiString(this.state.singleDate);

      let { entry } = this.props;

      const entryData = {
        ...entry,
        hours: toFinite(entry.hours),
        userId: this.props.user.userId,
        comment: this.state.comment,
        entryDate: entryDateString,
      };

      if (entry.id) {
        entry = await this.props.api.editTimeEntries(entry.id, entryData);
      } else {
        entry = await this.props.api.postTimeEntries(entryData);
      }

      if (!entry.id) {
        throw new Error("Expected an id to have been set on entry");
      }

      if (submit) {
        await this.props.api.submitEntries(entry.id);
      }

      this.setState({
        ...this.initialState,
        lastSavedDate: this.state.singleDate.clone(),
        loading: false,
        isConfirmationOpen: true,
        submit
      });

      this.props.onSaveNewTimeEntry();

      setTimeout(() => {
        this.setState({ isConfirmationOpen: false })
      }, MODAL_TIMEOUT);
    } catch (error) {
      this.setState({ loading: false });
      sentry.logException(error);
      alert("There was an unexpected error, please try again later.");
    }
  }

  async singleDayCheck(submit) {
    const entryDateString = dateUtils.dateToApiString(this.state.singleDate);
    const entriesToday = await this.props.api.getTimeEntries({
      startDate: entryDateString,
      endDate: entryDateString
    });
    const isEditing = Boolean(this.props.entry.id);
    if (entriesToday && entriesToday.aggregations && entriesToday.aggregations.hours) {
      const compareHours = Number(entriesToday.aggregations.hours.value)
        + Number(this.props.entry.hours)
        - Number(isEditing ? this.state.previousEditingHours : 0);

      if (compareHours >= 24) {
        this.setState({
          requiredFields: ["duration"],
          loading: false
        });
        alert('The total hours for this day exceeds 24 hours, please adjust your hours and try again.');
        return;
      }

      const workingHoursForDate = Number(this.props.workingHours[dateUtils.getDayNumber(this.state.singleDate)].workingHours);
      if (compareHours > workingHoursForDate) {
        confirm(
          `The total hours for this day (${compareHours}) exceeds the number of working hours you have configured for this date (${workingHoursForDate}). Are you sure you want to proceed?`,
          {title: 'Warning'}
        )
          .then(() => this.onSaveSingle(submit))
          .catch(() => this.setState({ loading: false }));

      } else {
        await this.onSaveSingle(submit);
      }
    }
  }

  /**
   * @param {boolean} submit
   * @return {Promise}
   */
  async onSaveMultiple(submit) {
    try {
      const tempDate = this.state.startDate.clone();

      const entries = [];

      const baseEntry = {
        ...this.props.entry,
        userId: this.props.user.userId,
        comment: this.state.comment,
        submit: Boolean(submit),
      };

      for (const { duration } of this.state.multiDayDurations) {
        const hours = toFinite(duration);

        if (hours > 0) {
          const entry = {
            ...baseEntry,
            hours,
            entryDate: dateUtils.dateToApiString(tempDate),
          };

          entries.push(entry);
        }

        tempDate.add(1, "day");
      }

      await this.props.api.postTimeEntryBatch(entries, submit);

      this.props.onSaveNewTimeEntry();

      this.setState({
        ...this.initialState,
        lastSavedDate: this.state.startDate.clone(),
        loading: false,
        isConfirmationOpen: true,
        submit
      });

      setTimeout(() => this.setState({ isConfirmationOpen: false }), MODAL_TIMEOUT);
    } catch (error) {
      alert('There was an unexpected error, please try again');
      this.setState({ loading: false });
      sentry.logException(error);
    }
  }

  async multiDayCheck(submit) {
    try {
      const date = this.state.startDate;
      let okState = 0;
      const waitingOnConfirmation = [];

      for (let i = 0; i < this.state.multiDayTimeEntryDaySpan; i++) {
        const entryDate = date.clone().add(i, 'day');
        const entryDateString = dateUtils.dateToApiString(entryDate);
        const entriesToday = await this.props.api.getTimeEntries({
          startDate: entryDateString,
          endDate: entryDateString
        });

        const hasHours = entriesToday && entriesToday.aggregations && entriesToday.aggregations.hours;

        if (hasHours) {
          const currentHours = Number(this.state.multiDayDurations[i].duration);
          const prevHours = Number(entriesToday.aggregations.hours.value);
          const hoursToday = prevHours + currentHours;
          if (hoursToday >= 24) {
            this.setState({
              requiredFields: [ 'multiDay-duration' ],
              loading: false
            });

            alert(`The total hours for ${entryDateString} exceeds 24 hours, please adjust your hours and try again.`);
            return;
          }

          const workingHoursForDate = Number(this.props.workingHours[dateUtils.getDayNumber(entryDate)].workingHours);
          if (hoursToday > workingHoursForDate) {
            waitingOnConfirmation.push({ entryDateString, workingHoursForDate, hoursToday });
          } else {
            okState++;
          }
        }
      }

      if (okState == this.state.multiDayTimeEntryDaySpan) { //Eveything went fine
        this.onSaveMultiple(submit);
      } else if (okState + waitingOnConfirmation.length == this.state.multiDayTimeEntryDaySpan) { // Just need to get confirmation
        const message = (
          <span>
            <p>The total amount of hours for the following
              {waitingOnConfirmation.length > 1 ? ' days' : ' day'} exceeds the number of working hours configured:</p>
            {waitingOnConfirmation.map((d, i) => {
              return (<div key={`${d.entryDateString}-${i}`}>{d.entryDateString}: {d.hoursToday} ({d.workingHoursForDate} working hours)<br /></div>);
            })}
            <p>Are you sure you want to proceed?</p>
          </span>
        );

        confirm(message, {title: 'Warning'})
          .then(() => this.onSaveMultiple(submit))
          .catch((error) => this.setState({ loading: false }));

      } else {
        this.setState({ loading: false });
      }

    } catch (error) {
      alert('There was an unexpected error, please try again');
      this.setState({ loading: false });
      sentry.logException(error);
    }
  }

  async onSave(submit = false) {
    this.setState({ loading: true });
    try {
      if (!this.checkRequiredFields()) {
        this.setState({ loading: false });
        return;
      }

      if (this.state.singleView) {
        this.singleDayCheck(submit);
      } else {
        this.multiDayCheck(submit);
      }
    } catch (error) {
      alert('There was an unexpected error, please try again');
      this.setState({ loading: false });
      sentry.logException(error);
    }
  }

  onSubmit() {
    this.onSave(true);
  }

  onCancel() {
    this.setState({ ...this.initialState });
    this.props.onCancel();
  }

  onReset() {
    this.onCancel();
  }

  _renderModals() {
    return [
      <Modal
        ariaHideApp={false}
        key="activityModal"
        isOpen={this.props.isActivityCategoryOpen}
        contentLabel="Activity Modal"
        onRequestClose={() => this.props.modalController("CLOSE_ALL")}
        style={MODAL_SETTINGS}
        contentLabel="Activity modal"
      >
        <ActivityModal
          content={this.props.categoriesList}
          closeModal={() => this.props.modalController("CLOSE_ALL")}
        />
      </Modal>,
      <BaseModal
        key="selectAccountModal"
        title="Select Your Account"
        contentLabel="Select Your Account Modal"
        containerClass="searchListModal"
        isOpen={this.state.isAccountOpen}
        onRequestClose={() => this.setState({ isAccountOpen: false })}
      >
        <AccountSearchSelectList onSelectItem={this.onSelectAccount.bind(this)} />
      </BaseModal>,
      <BaseModal
        key="selectProductModal"
        contentLabel="Select Your Product Modal"
        title="Select Your Product Group"
        containerClass="searchListModal"
        isOpen={this.state.isProductGroupOpen}
        onRequestClose={() => this.setState({ isProductGroupOpen: false })}
      >
        <ProductGroupSearchSelectList
          onSelectItem={this.onSelectProductGroup.bind(this)}
        />
      </BaseModal>,
      <BaseModal
        key="selectDistributorModal"
        title="Select Your Distributor"
        contentLabel="Select Your Distributor Modal"
        containerClass="searchListModal"
        isOpen={this.state.isDistributorOpen}
        onRequestClose={() => this.setState({ isDistributorOpen: false })}
      >
        <DistributorSearchSelectList
          onSelectItem={this.onSelectDistributor.bind(this)}
        />
      </BaseModal>,
      <BaseModal
        key="selectOpportunityModal"
        contentLabel="Select Opportunity Modal"
        title="Select Opportunity"
        containerClass="searchListModal"
        isOpen={this.state.isOpportunityOpen}
        onRequestClose={() => this.setState({ isOpportunityOpen: false })}
      >
        <OpportunitySearchSelectList
          entry={this.props.entry}
          onSelectItem={this.onSelectOpportunity.bind(this)}
        />
      </BaseModal>,
      <BaseModal
        key="selectServiceRequestModal"
        title="Select Your Service Request"
        contentLabel="Select Your Suppor Request Modal"
        containerClass="searchListModal"
        isOpen={this.state.isServiceRequestOpen}
        onRequestClose={() => this.setState({ isServiceRequestOpen: false })}
      >
        <ServiceRequestSearchSelectList onSelectItem={this.onSelectServiceRequest.bind(this)} />
      </BaseModal>,
      <Modal
        key="submitConfirmationModal"
        isOpen={this.state.isConfirmationOpen && this.props.showConfirmations}
        contentLabel="Submit Confirmation Modal"
        onRequestClose={() => this.setState({ isConfirmationOpen: false })}
        style={SUBMIT_MODAL_SETTINGS}
        contentLabel="Confirmation modal"
      >
        <SubmitModal
          submitted={this.state.submit}
          closeModal={() => this.setState({ isConfirmationOpen: false })}
        />
      </Modal>
    ];
  }

  render() {
    const isEditing = Boolean(this.props.entry.id);
    const isCloning = Boolean(this.props.entry._clonedFrom);
    const isSubmitted = Boolean(this.props.entry.submitDate);
    const entry = this.props.entry;

    let headerText = "Create a Time Entry";

    if (isEditing) {
      headerText = "Editing Time Entry";
    } else if (isCloning) {
      headerText = "Cloning a Time Entry";
    }

    return (
      <Container>
        <Loader
          show={this.state.loading}
          {...loaderSettings}
          message={"saving..."}
        >
          <Notice />
          <section className="timeinput container-fluid">
            <div className="row input-header">
              <div className="col-lg-6 col-sm-6 col-xs-12 inputTitle">
                <h1>{headerText}</h1>
              </div>
              {(!isEditing && !isCloning) &&
              <div className="col-lg-6 col-sm-6 col-xs-12 input-toggle">
                <button
                  className={this.state.singleView ? "btn-active" : null}
                  onClick={() => { this.setState({ singleView: true }) }}
                >Single-Day</button>
                <button
                  className={!this.state.singleView ? "btn-active" : null}
                  onClick={() => { this.setState({ singleView: false }) }}
                >Multi-Day</button>
              </div>}
            </div>

            <div className="row input-fields">
              <InputField
                hasError={this.state.requiredFields.includes("category")}
                title="Activity/Category"
                type="button"
                placeholder="Select your activity/category"
                value={entry.category ? entry.category : ""}
                colClass="col-lg-6 col-sm-6 col-xs-12"
                onClick={() => this.props.modalController("ACTIVITY")}
                onClear={() => this.props.setInputField("CATEGORY", null)}
                required={true}
              />
              <DateInput
                allowForecasting={(entry.categoryObject) ? entry.categoryObject.allowForecasting : false}
                duration={entry.hours}
                endDate={this.state.endDate}
                multiDayDurations={this.state.multiDayDurations}
                multiDayTimeEntryDaySpan={this.state.multiDayTimeEntryDaySpan}
                requiredFields={this.state.requiredFields}
                singleDate={this.state.singleDate}
                singleView={this.state.singleView}
                startDate={this.state.startDate}
                totalDuration={this.getTotalDurationMultiDay()}
                updateDuration={this.updateDuration.bind(this)}
                updateDurationMulti={this.updateDurationMulti.bind(this)}
                updateMultiDate={this.updateMultiDate.bind(this)}
                updateSingleDate={this.updateSingleDate.bind(this)}
                workingHours={this.props.workingHours}
              />

              {entry.category ?
                <div>
                  {(this.state.fields.serviceRequest === "hidden")
                    ? null
                    : (<div className="col-xs-12"><hr /></div>)}

                  <ServiceRequestField
                    colClass="col-sm-6 col-xs-12"
                    entry={entry}
                    fieldPermission={this.state.fields.serviceRequest}
                    hasError={this.state.requiredFields.includes("serviceRequest")}
                    onClick={() => this.setState({ isServiceRequestOpen: true })}
                    onClear={() => this.props.setInputField("SERVICEREQUEST", null)}
                  />

                  {(this.state.fields.account === "hidden"
                      && this.state.fields.location === "hidden"
                      && this.state.fields.onsite === "hidden"
                      && this.state.fields.competitiveReplacement === "hidden")
                        ? null
                        : <Separator />}

                  <AccountField
                    colClass="col-sm-6 col-xs-12"
                    entry={entry}
                    fieldPermission={this.state.fields.account}
                    hasError={this.state.requiredFields.includes("account")}
                    onClick={() => this.setState({ isAccountOpen: true })}
                    onClear={() => {
                      this.props.setInputField("ACCOUNT", null);
                      this.props.setInputField("LOCATION", null);
                      this.props.setInputField("OPPORTUNITY", null);
                    }}
                  />

                  <LocationField
                    colClass="col-sm-6 col-xs-12"
                    entry={entry}
                    fieldPermission={this.state.fields.location}
                    hasError={this.state.requiredFields.includes("location")}
                    locationsList={this.props.locationsList}
                    onSelectLocation={(option) => this.onSelectLocation(option)}
                  />

                  <CheckboxField
                    hasError={this.state.requiredFields.includes("onsite")}
                    hidden={this.state.fields.onsite === "hidden"}
                    title="On Site"
                    colClass="col-sm-6 col-xs-12 on-site-button push-right"
                    disabled={this.props.locationsList.length == 0}
                    disabledClass={this.props.locationsList.length == 0 ? "checkbox-disabled" : null}
                    checked={entry.onsite}
                    onChange={(e) => { this.props.setOnsite(e.target.checked) }}
                  />

                  {(this.state.fields.onsite !== "hidden") ? <Break /> : null}

                  <SelectField
                    label="With Customer?"
                    colClass="col-sm-6 col-xs-12 push-right"
                    options={ONSITE_DETAIL_OPTIONS}
                    value={entry.onsiteDetail}
                    onChange={(option) => { this.onSelectOnsiteDetail(option) }}
                    hidden={this.state.fields.onsiteDetail === "hidden"}
                    disabled={this.state.fields.onsiteDetail === "hidden"}
                    required={this.state.fields.onsiteDetail !== "hidden"}
                    hasError={this.state.requiredFields.includes("onsiteDetail")}
                  />

                  {(this.state.fields.onsite !== "hidden" && this.state.fields.competitiveReplacement !== "hidden") ? <Break /> : null}

                  <CheckboxField
                    hasError={this.state.requiredFields.includes("competitiveReplacement")}
                    hidden={this.state.fields.competitiveReplacement === "hidden"}
                    title="Competitive Replacement"
                    colClass="col-sm-6 col-xs-12 on-site-button push-right"
                    checked={entry.competitiveReplacement}
                    onChange={(e) => { this.props.setCompetitiveReplacement(e.target.checked) }}
                  />

                  {(this.state.fields.productGroup === "hidden"
                      && this.state.fields.distributor === "hidden"
                      && this.state.fields.opportunity === "hidden")
                        ? null
                        : <Separator />}

                  <InputField
                    hasError={this.state.requiredFields.includes("productGroup")}
                    required={this.state.fields.productGroup === "required"}
                    hidden={this.state.fields.productGroup === "hidden"}
                    title="Product Group"
                    type="button"
                    placeholder="Select your product group"
                    value={entry.productGroup && entry.productGroup.productGroupDescr
                      ? entry.productGroup.productGroupDescr
                      : ""}
                    colClass="col-sm-6 col-xs-12"
                    onClick={() => this.setState({ isProductGroupOpen: true })}
                    onClear={() => {
                      this.props.setInputField("PRODUCTGROUP", null);
                      this.props.setInputField("PRODUCTLINE", null);
                    }}
                  />

                  <SelectField
                    label="Product Line"
                    colClass="col-sm-6 col-xs-12"
                    options={
                      (entry.productGroup.productLines)
                        ? entry.productGroup.productLines.map((line) => ({
                          label: line.productLineDescr,
                          value: line.productLineId,
                          ref: line
                        }))
                        : []
                    }
                    placeholder="Product line"
                    value={(entry.productLine) ? entry.productLine.productLineId : null}
                    onChange={(option) => this.onSelectProductLine(option)}
                    hidden={this.state.fields.productGroup === "hidden" || this.state.fields.productLine === "hidden"}
                    disabled={!entry.productGroup.productGroupId}
                    required={this.state.fields.productLine === "required"}
                    hasError={this.state.requiredFields.includes("productLine")}
                  />

                  <InputField
                    hasError={this.state.requiredFields.includes("distributor")}
                    required={this.state.fields.distributor === "required"}
                    hidden={this.state.fields.distributor === "hidden"}
                    title="Distributor"
                    type="button"
                    placeholder="Select distributor"
                    value={entry.distributor.distributorName
                      ? entry.distributor.distributorName
                      : ""}
                    colClass="col-sm-6 col-xs-12"
                    onClick={() => this.setState({isDistributorOpen: true})}
                    onClear={() => {
                      this.props.setInputField("DISTRIBUTOR", null);
                    }}
                  />

                  <OpportunityField
                    colClass="col-sm-6 col-xs-12"
                    entry={entry}
                    fieldPermission={this.state.fields.opportunity}
                    hasError={this.state.requiredFields.includes("opportunity")}
                    onSelectOpportunity={option => this.onSelectOpportunity(option)}
                    opportunitiesList={this.props.opportunitiesList}
                    onClick={() => this.setState({ isOpportunityOpen: true })}
                    onClear={() => this.props.setInputField("OPPORTUNITY", null)}
                  />

                  <InterlockField
                    colClass="col-sm-6 col-xs-12"
                    entry={entry}
                    fieldPermission={this.state.fields.interlock}
                    hasError={this.state.requiredFields.includes("interlock")}
                    onSelectInterlock={(option) => this.onSelectInterlock(option)}
                    interlockList={this.props.interlockList}
                    entry={this.props.entry}
                  />
                </div>: null}

              <Separator />

              <TextareaField
                value={this.state.comment}
                onChange={text => {this.setState({comment: text});}}
                title="Add Comment (Optional)"
                placeholder="Comment..."
                type="textarea"
                colClass="col-xs-12"
              />

              <Buttons
                isCloning={isCloning}
                isEditing={isEditing}
                isSubmitted={isSubmitted}
                onCancel={() => this.onCancel()}
                onReset={() => this.onReset()}
                onSave={() => this.onSave()}
                onSubmit={() => this.onSubmit()}
                userCanSave={this._areSaveButtonsEnabled()}
              />
              {this._renderModals()}
            </div>
          </section>
        </Loader>
      </Container>
    );
  }
}

export function Break() {
  return (
    <div className="col-xs-12"><br /></div>
  );
}

export function Separator() {
  return (
    <div className="col-xs-12"><hr /></div>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    categoriesList: state.categories.categoriesList,
    api: state.api,
    defaultServiceRequest: state.serviceRequests.defaultServiceRequest,
    editingEntry: state.editingEntry,
    entry: state.entry,
    isActivityCategoryOpen: state.modal.isActivityCategoryOpen,
    locationsList: state.locations.locationsList,
    multiView: state.dom.multiView,
    opportunitiesList: state.opportunities.opportunitiesList,
    interlockList: state.interlock.interlockList,
    serviceRequests: state.serviceRequests.serviceRequestsList,
    settings: state.settings,
    showConfirmations: state.settings.confirmations,
    singleView: state.dom.singleView,
    user: state.user,
    userRole: state.userRole,
    userState: state.userState,
    workingHours: state.settings.workingHours
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    toggleInput: (currentState) => dispatch(toggleInput(currentState)),
    modalController: (currentModal) => dispatch(modalController(currentModal)),
    selectAccount: (account) => dispatch(setInputField("ACCOUNT", account)),
    selectLocation: (location) => dispatch(setInputField("LOCATION", location)),
    selectProductGroup: (productGroup) => dispatch(setInputField("PRODUCTGROUP", productGroup)),
    selectProductLine: (productLine) => dispatch(setInputField("PRODUCTLINE", productLine)),
    selectDistributor: (distributor) => dispatch(setInputField("DISTRIBUTOR", distributor)),
    setCompetitiveReplacement: (value) => dispatch(setInputField("COMPETITIVE_REPLACEMENT", value)),
    setOnsite: (value) => dispatch(setInputField("ONSITE", value)),
    selectOpportunity: (opportunity) => dispatch(setInputField("OPPORTUNITY", opportunity)),
    selectInterlock: (interlock) => dispatch(setInputField("INTERLOCK", interlock)),
    selectServiceRequest: (serviceRequest) => dispatch(setInputField("SERVICEREQUEST", serviceRequest)),
    onSaveNewTimeEntry: () => {
      dispatch({ type: "CLEAR_ALL_INPUT" });
      dispatch({ type: "SAVED_ENTRY" });
      dispatch(updateDefaultSelections());
      dispatch(refreshEntries());
    },
    onCancel: () => dispatch({ type: "CLEAR_ALL_INPUT" }),
    addNotification: (notification) => dispatch(addNotification(notification)),
    toggleHistory: (toggle) => dispatch(toggleHistory(toggle)),
    setInputField: (field, value) => dispatch(setInputField(field, value)),
    setEntry: (entry) => dispatch({ type: "SET_ENTRY", payload: entry })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeInput);

function deriveInitialStateFrom(props) {
  const initSpan = 2;
  const dayNumber = dateUtils.getDayNumber();
  const startDate = moment(0, "HH").subtract(1, "day");

  const entryCategory = get(props, "entry.categoryObject");

  const fields = calculateCategoryFieldsFor(entryCategory, props.user);

  const initialState = {
    cloning: false,
    comment: "",
    dayNumber,
    duration: "0.0",
    editing: false,
    endDate: moment(0, "HH"),
    fields,
    isAccountOpen: false,
    isConfirmationOpen: false,
    isDistributorOpen: false,
    isOpportunityOpen: false,
    isProductGroupOpen: false,
    isServiceRequestOpen: false,
    lastSavedDate: null,
    loading: false,
    multiDayDurationEdited: {},
    multiDayDurations: [],
    multiDayTimeEntryDaySpan: initSpan,
    previousEditingHours: 0,
    requiredFields: [],
    singleDate: moment(0, "HH"),
    singleDayDurationEdited: false,
    singleView: true,
    startDate,
  };

  const isInitialState = Boolean(get(props, "settings.initialState", true));

  if (!isInitialState) {
    initialState.duration = getWorkingHoursFrom(props, dayNumber, "0.0");

    initialState.multiDayDurations = getMultiDayDurations(startDate, initSpan, null, initialState, props);
  }

  return initialState;
}

function getMultiDayDurations(startDate, daySpan, currentData, state, props) {
  const multiDayDurations = [];

  for (const i of times(daySpan)) {
    const currentDate = moment(startDate).add(i, "day");
    const multipleDayNumber = dateUtils.getDayNumber(currentDate);

    let hours = "0.0";
    let useDefaults = true;

    if (currentData != null) {
      if (isMultiDayDurationFieldEdited(currentDate, state)) {
        const previousValue = getMultiDayDurationByDate(currentDate, state);

        if (toFinite(previousValue) > 0) {
          hours = previousValue;
          useDefaults = false;
        }
      }
    }

    if (useDefaults) {
      hours = getWorkingHoursFrom(props, multipleDayNumber);
    }

    multiDayDurations.push({
      date: dateUtils.dateToString(currentDate),
      duration: hours
    });
  }

  return multiDayDurations;
}

/**
 * @param {Date} theDate
 * @return {string}
 */
function getMultiDayDurationByDate(theDate, state) {
  const dateAsString = dateUtils.dateToString(theDate);

  const found = find(state.multiDayDurations, { date: dateAsString });

  if (found) {
    return found.duration;
  }

  return "";
}

function getWorkingHoursFrom(props, dayNumber, defaultValue = "0.0") {
  const enabled = get(props, ["workingHours", dayNumber, "enabled"], false);

  const config = get(props, ["workingHours", dayNumber]);

  return get(config, "enabled") ? get(config, "workingHours", defaultValue) : defaultValue;
}

function getWorkingHoursForDate(props, dateish, defaultValue = "0.0") {
  const dayNumber = dateUtils.getDayNumber(dateish);

  return getWorkingHoursFrom(props, dayNumber, defaultValue);
}

/**
 * @param {Date} theDate
 * @return {boolean}
 */
function isMultiDayDurationFieldEdited(theDate, state) {
  const key = dateUtils.dateToString(theDate);

  return Boolean(get(state, ["multiDayDurationEdited", key]));
}

function propDiff(leftProps, rightProps, path, checker) {
  const left = get(leftProps, path);
  const right = get(rightProps, path);

  if (left !== right) {
    if (typeof checker === "function") {
      return checker(left, right);
    }

    return true;
  }

  return false;
}

const leftPresent = (left, _) => Boolean(left);

function propDiffPresent(leftProps, rightProps, path) {
  return propDiff(leftProps, rightProps, path, leftPresent);
}

function propDiffNowBlank(leftProps, rightProps, path) {
  return propDiff(leftProps, rightProps, path, function(left, right) {
    return Boolean(right) && !Boolean(left);
  });
}

function propDiffThen(leftProps, rightProps, path, then) {
  const left = get(leftProps, path);
  const right = get(rightProps, path);

  if (left !== right) {
    if (typeof then === "function") {
      then(left);
    }

    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./app/components/TimeInput/TimeInput.jsx